import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React, { useState } from 'react';
import { reviewsListPropTypes } from './ReviewsListPropTypes';
import Star from '@Theme/natucare/components/Star/Star';
import * as styles from './ReviewsList.module.scss';
const ReviewsList = ({
  reviews,
  showMoreButtonText
}) => {
  if (!reviews) {
    return null;
  }
  const {
    0: reviewsVisible,
    1: setReviewsVisible
  } = useState(10);
  const handleShowMoreReviews = e => {
    e.preventDefault();
    setReviewsVisible(prev => prev + 10);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: styles.root
  }, reviews.slice(0, reviewsVisible).map((review, index) => {
    const fullStars = Math.floor(review.stars);
    const halfStars = Math.round(review.stars - fullStars);
    return /*#__PURE__*/React.createElement("li", {
      className: styles.rootItem,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.rootHeader
    }, review.stars && /*#__PURE__*/React.createElement("div", {
      className: styles.rootHeaderStars
    }, _toConsumableArray(Array(5)).map((_, index) => {
      const value = 5 - index;
      const filled = value <= fullStars;
      const half = value === fullStars + 1 && halfStars > 0;
      return /*#__PURE__*/React.createElement(Star, {
        classname: styles.rootHeaderStarsStar,
        "data-value": value,
        filled: filled,
        half: half,
        key: value
      });
    })), review.date && /*#__PURE__*/React.createElement("div", {
      className: styles.rootHeaderDate
    }, review.date)), /*#__PURE__*/React.createElement("div", {
      className: styles.rootReview,
      dangerouslySetInnerHTML: {
        __html: review.text
      }
    }));
  })), reviews.length > reviewsVisible && showMoreButtonText && /*#__PURE__*/React.createElement("button", {
    className: styles.rootButton,
    onClick: handleShowMoreReviews
  }, showMoreButtonText));
};
export default ReviewsList;